import { createSelector } from 'reselect';

export const selectedSearchClaims = (state: any) => {
  return state.get('searchClaims');
};

const makeSelectedClaims = () =>
  createSelector(selectedSearchClaims, claims => {
    if (claims && claims.get('searchClaims')) {
      const selectedClaim = claims.get('selectedClaim');
      return selectedClaim;
    }
    return null;
  });

const makeSelectFoundClaims = () =>
  createSelector(selectedSearchClaims, claims => {
    if (claims && claims.get('foundClaims')) {
      const foundClaims = claims.get('foundClaims').toJS();
      return foundClaims;
    }
    return null;
  });

const makeSelectSearchClaims = () =>
  createSelector(selectedSearchClaims, claims => {
    if (claims && claims.get('searchClaims')) {
      const lossDate = claims.get('lossDate');
      const sagisResults = claims.get('searchClaims').toJS();
      return { ...sagisResults, lossDate };
    }
    return {};
  });

export { makeSelectSearchClaims, makeSelectedClaims, makeSelectFoundClaims };
